export enum ShiftState {
  NotSubmitted = 'not-submitted',
  Submitted = 'submitted',
  Reopened = 'reopened',
  AcceptedTimes = 'accepted-times',
  SubmittedToPayrollProvider = 'submitted-to-payroll-provider',
}
